import { render } from "./LandingMR.vue?vue&type=template&id=581ad233"
import script from "./LandingMR.vue?vue&type=script&lang=js"
export * from "./LandingMR.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__